import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload } from "@obg/ngrx-utils";

import { AppError } from "../../app-error/app-error.model";

import { OpenIdConnectAuthRequest } from "./google-auth-transaction.model";

export const ACTION_PREFIX = "[Google Auth Transaction]";
export const GOOGLE_AUTH_TRANSACTION_ACTION_TYPE = {
	initializeOidcAuthTransaction: `${ACTION_PREFIX} Initialize Oidc Auth Transaction`,
	setOpenIdConnectUrl: `${ACTION_PREFIX} Set Open Id Connect App Url`,
	setOpenIdConnectUrlSuccess: `${ACTION_PREFIX} Set Open Id Connect App Url Success`,
	setOpenIdConnectUrlFail: `${ACTION_PREFIX} Set Open Id Connect App Url Fail`,
	setCurrentJourney: `${ACTION_PREFIX} Set Current Journey`,
	reset: `${ACTION_PREFIX} Reset`,
};

@Injectable({
	providedIn: "root",
})
export class GoogleAuthTransactionAction {
	initializeOidcAuthTransaction(payload: OpenIdConnectAuthRequest): ActionWithPayload {
		return {
			type: GOOGLE_AUTH_TRANSACTION_ACTION_TYPE.initializeOidcAuthTransaction,
			payload,
		};
	}

	setCurrentJourney(payload: string): ActionWithPayload {
		return {
			type: GOOGLE_AUTH_TRANSACTION_ACTION_TYPE.setCurrentJourney,
			payload,
		};
	}

	setOpenIdConnectUrl(): Action {
		return {
			type: GOOGLE_AUTH_TRANSACTION_ACTION_TYPE.setOpenIdConnectUrl,
		};
	}

	setOpenIdConnectUrlSuccess(payload: string): ActionWithPayload {
		return {
			type: GOOGLE_AUTH_TRANSACTION_ACTION_TYPE.setOpenIdConnectUrlSuccess,
			payload,
		};
	}

	setOpenIdConnectUrlFail(error: AppError): ActionWithPayload {
		return {
			type: GOOGLE_AUTH_TRANSACTION_ACTION_TYPE.setOpenIdConnectUrlFail,
			payload: error,
		};
	}

	reset(): Action {
		return {
			type: GOOGLE_AUTH_TRANSACTION_ACTION_TYPE.reset,
		};
	}
}
